function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { EMPTY_FUNCTION } from '@deephaven/utils';
import { SELECTION_DIRECTION } from "./GridRange.js";
import GridUtils from "./GridUtils.js";
import "./CellInputField.css";
import { jsx as _jsx } from "react/jsx-runtime";
var directionForKey = key => {
  switch (key) {
    case 'ArrowDown':
      return SELECTION_DIRECTION.DOWN;
    case 'ArrowUp':
      return SELECTION_DIRECTION.UP;
    case 'ArrowLeft':
      return SELECTION_DIRECTION.LEFT;
    case 'ArrowRight':
      return SELECTION_DIRECTION.RIGHT;
    default:
      return undefined;
  }
};
export function CellInputField(_ref) {
  var selectionRange = _ref.selectionRange,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$value = _ref.value,
    propsValue = _ref$value === void 0 ? '' : _ref$value,
    _ref$isQuickEdit = _ref.isQuickEdit,
    propsIsQuickEdit = _ref$isQuickEdit === void 0 ? true : _ref$isQuickEdit,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? EMPTY_FUNCTION : _ref$onChange,
    _ref$onCancel = _ref.onCancel,
    onCancel = _ref$onCancel === void 0 ? EMPTY_FUNCTION : _ref$onCancel,
    _ref$onDone = _ref.onDone,
    onDone = _ref$onDone === void 0 ? EMPTY_FUNCTION : _ref$onDone,
    style = _ref.style;
  var inputField = useRef(null);
  // Use a ref for `isCancelled` as we need to know when it's cancelled after it's called by the event handlers as well
  var isCancelled = useRef(false);
  var _useState = useState(propsValue),
    _useState2 = _slicedToArray(_useState, 1),
    initialValue = _useState2[0];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isChanged = _useState4[0],
    setIsChanged = _useState4[1];
  var _useState5 = useState(propsIsQuickEdit),
    _useState6 = _slicedToArray(_useState5, 2),
    isQuickEdit = _useState6[0],
    setIsQuickEdit = _useState6[1];
  var _useState7 = useState(propsValue),
    _useState8 = _slicedToArray(_useState7, 2),
    value = _useState8[0],
    setValue = _useState8[1];

  // Init field selection
  useEffect(function selectInputField() {
    var field = inputField.current;
    if (field == null) {
      return;
    }
    field.focus();
    if (selectionRange) {
      field.setSelectionRange(selectionRange[0], selectionRange[1]);
    } else {
      field.setSelectionRange(field.value.length, field.value.length);
    }
  }, [selectionRange]);
  var sendUpdate = useCallback(newValue => {
    onChange(newValue);
  }, [onChange]);
  var handleChange = useCallback(event => {
    var newValue = event.target.value;
    setValue(newValue);
    setIsChanged(true);
    sendUpdate(newValue);
  }, [sendUpdate, setValue, setIsChanged]);
  var handleCancel = useCallback(() => {
    isCancelled.current = true;
    if (isChanged) {
      sendUpdate(initialValue);
    }
    setIsChanged(false);
    onCancel();
  }, [initialValue, isChanged, onCancel, sendUpdate]);
  var handleClick = useCallback(() => {
    setIsQuickEdit(false);
  }, [setIsQuickEdit]);
  var handleCommit = useCallback(function (direction) {
    var fillRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    onDone(value, {
      direction,
      fillRange
    });
  }, [onDone, value]);
  var handleBlur = useCallback(() => {
    if (isCancelled.current) {
      return;
    }
    handleCommit(null);
  }, [isCancelled, handleCommit]);
  var handleKeyDown = useCallback(event => {
    event.stopPropagation();
    switch (event.key) {
      case 'Escape':
        event.preventDefault();
        handleCancel();
        break;
      case 'Enter':
        event.preventDefault();
        if (GridUtils.isModifierKeyDown(event)) {
          handleCommit(undefined, true);
        } else if (event.altKey) {
          var newValue = "".concat(value, "\n");
          setValue(newValue);
          setIsChanged(true);
          sendUpdate(newValue);
        } else {
          handleCommit(event.shiftKey ? SELECTION_DIRECTION.UP : SELECTION_DIRECTION.DOWN);
        }
        break;
      case 'Tab':
        event.preventDefault();
        handleCommit(event.shiftKey ? SELECTION_DIRECTION.LEFT : SELECTION_DIRECTION.RIGHT);
        break;
      case 'ArrowDown':
      case 'ArrowUp':
      case 'ArrowLeft':
      case 'ArrowRight':
        if (isQuickEdit) {
          event.preventDefault();
          handleCommit(directionForKey(event.key));
        }
        break;
      default:
        break;
    }
  }, [handleCancel, handleCommit, isQuickEdit, setValue, setIsChanged, sendUpdate, value]);
  return /*#__PURE__*/_jsx("textarea", {
    ref: inputField,
    className: classNames('grid-cell-input-field', className),
    value: value,
    onBlur: handleBlur,
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    onClick: handleClick,
    autoComplete: "off",
    autoCorrect: "off",
    autoCapitalize: "off",
    spellCheck: "false",
    disabled: disabled,
    style: style
  });
}
export default CellInputField;
//# sourceMappingURL=CellInputField.js.map